export default {
  cnCode: "商品編碼",
  factorValue: "排放係數",
  unit: "單位",
  coefficient: "製程係數",
  description: "描述",
  createdAt: "建立時間",
  updatedAt: "更新時間",
  action: "操作",
  error: "錯誤",
  search: "搜尋",
  add: "新增係數",
  edit: "編輯",
  template: "模板",
  csvTemplate: "CSV 模板",
  xlsxTemplate: "XLSX 模板",
  deleteConfirm: "確定要刪除此係數嗎？",
  deleteConfirmBatch: "確定要刪除這些係數嗎？",
  import: "匯入係數",
  export: "匯出係數",
  close: "關閉",
  reset: "重新匯入",
  resetConfirm: "確定要重新匯入嗎？",
  ok: "確定",
  clearInvalid: "清除無效資料",
  showErrorRows: "顯示錯誤資料",
  hideErrorRows: "隱藏錯誤資料",
  placeholder: {
    cnCode: "輸入商品編碼（例如：'24'）",
    factorValue: "輸入排放係數",
    coefficient: "輸入製程係數（0-1）",
    description: "輸入描述（例如：'用於低碳鋼生產'）",
    unit: "選擇單位",
  },
  cnCodeRequired: "請輸入商品編碼",
  cnCodeMaxLength: "商品編碼不能超過 20 個字元",
  cnCodeFormat: "商品編碼只能包含字母、數字和底線",
  cnCodeExample: "例如：鋼鐵商品編碼 '24'，排放係數 1.5，製程係數 0.8",
  factorValueRequired: "請輸入排放係數",
  factorValueMin: "排放係數必須大於 0",
  factorValueUnit: "單位為 kg CO2e/kg，水泥需轉換為此單位",
  coefficientRequired: "請輸入製程係數",
  coefficientRange: "製程係數必須在 0 到 1 之間",
  descriptionMaxLength: "描述不能超過 255 個字元",
  fetchError: "獲取係數失敗",
  addSuccess: "係數新增成功",
  addError: "係數新增失敗",
  editSuccess: "係數更新成功",
  editError: "係數更新失敗",
  deleteSuccess: "係數刪除成功",
  deleteError: "係數刪除失敗",
  exportSuccess: "匯出成功",
  exportError: "係數匯出失敗",
  uploadFormatError: "僅支援 CSV 或 XLSX 檔案",
  headerInvalid: "檔案標頭無效，應為：cn_code,factor_value,coefficient,description",
  headerSkipped: "已跳過標頭行",
  importLimitExceeded: "匯入資料超出限制（最多 {max} 行有效資料）",
  noValidData: "無有效的係數資料",
  parseError: "檔案解析失敗",
  importError: "係數匯入失敗",
  importSuccess: "成功匯入 {count} 個係數",
  clearInvalidSuccess: "已清除 {count} 行無效資料",
  noInvalidData: "無需清除的無效資料",
  uploadText: "點擊或拖拽檔案到此區域以上傳",
  uploadHint: "支援 CSV 和 XLSX 格式",
  unitRequired: "請選擇單位",
  unitInvalid: "單位無效，僅支援 kg CO2e/kg 或 kg CO2e/噸",
  batchDelete: "批次刪除",
  batchDeleteSuccess: "成功刪除 {count} 個係數",
  batchDeleteError: "批次刪除係數失敗",
};
